import { useMemo } from 'react'
import { FeaturesPlayer } from 'player'
import { Task } from '../../../../types'
import { UseModalPaywall } from '../../../../hooks/event/use-modal-paywall'
import { useFeaturesChangeOperations } from './use-features-change-operations'
import { UseChangeOperations } from '../../../../hooks/tasks/use-upgradability-new/use-change-operations'

type UseFeaturesProps = {
  task: Task
  modalPaywall: UseModalPaywall
  changeOperations: UseChangeOperations
}

export const useFeatures = ({
  task,
  modalPaywall,
  changeOperations
}: UseFeaturesProps): FeaturesPlayer => {
  const ChangeOperations = useFeaturesChangeOperations({
    task,
    modalPaywall,
    changeOperations
  })

  return useMemo<FeaturesPlayer>(() => {
    return { ChangeOperations }
  }, [ChangeOperations])
}
